import {
  chakra,
  chartjs,
  css,
  express,
  html,
  javascript,
  mongodb,
  node,
  promptEngineering,
  react,
  redux,
  tailwind,
  typescript,
  nextjs,
  threejs,
  gsap,
  firebase,
  angular,
  jquery,
  socket,
  bootstrap,
  amazon,
  graphql,
  wordpress,
  mySQL
} from "./techstack";

export const ProjectList = [
  {
    heading: "Ciela",
    img: "/ciela.png",
    title: "Ciela",
    description:
      "It is particle effect using gsap.",
    techStack: [wordpress,gsap,threejs,node,bootstrap,mySQL],
    liveLink: "https://ciela.science/",
  },
  {
    heading: "Acko",
    img: "/acko.png",
    title: "Acko",
    description:
      "It is hackery math design.",
    techStack: [gsap,threejs,node],
    liveLink: "https://acko.net/",
  },
  {
    heading: "Uncanny Valley",
    img: "/uncanny.png",
    title: "Uncanny Valley",
    description:
      "It is tube effect using gsap.",
    techStack: [gsap,express,threejs,node,bootstrap],
    liveLink: "https://uncannyvalley.studio/",
  },
  {
    heading: "Anvl",
    img: "/anvl.png",
    title: "Anvl",
    description:
      "It is character making game.",
    techStack: [threejs,graphql,jquery,bootstrap],
    liveLink: "https://anvl.co/",
  },
  {
    heading: " TEXT TO SPEECH",
    img: "https://raw.githubusercontent.com/SumatM/Text-To-Speech/main/Screenshot%20(712).png",
    title: " JavaScript Speech Synthesis",
    description:
      "WebPage that converts written text into spoken words. Utilized natural language processing techniques to analyze and interpret the text, generating synthesized speech output.",
    techStack: [html, javascript, css],
    liveLink: "https://text-to-speech-sumat.netlify.app/",
  },
  {
    heading: "E.M.S",
    img: "https://raw.githubusercontent.com/SumatM/typeScript-learning/e1f49f5f02d1400869046f783090a7f8762b7c47/mock_demo/frontend/src/assets/Screenshot%20(759).png",
    title: "Employee Management System",
    description:
      "Employee Management System with authentication, authorization, sorting, filtering, pagination, and search capabilities. Seamlessly manage employees, tracking their data efficiently and ensuring secure access. Simplify HR tasks with this comprehensive solution.",
    techStack: [react, typescript, chakra, redux, node, express, mongodb],
    liveLink: "https://ems-ebon.vercel.app/",
  },
  {
    heading: "Hero Game",
    img: "/hero.png",
    title: "Hero Game",
    description:
      "It is desktop hero game.",
    techStack: [threejs,graphql,jquery,bootstrap],
    liveLink: "https://desktophero3d.com/",
  },
  {
    heading: "Web Averse",
    img: "/averse.png",
    title: "Web Averse",
    description:
      "It is interesting game using wasd keyboard.",
    techStack: [threejs,firebase],
    liveLink: "https://webaverse.com/",
  },
  {
    heading: "Award Game",
    img: "/award.png",
    title: "Award Game",
    description:
      "It is game using wasd keyboard.",
    techStack: [threejs,node, firebase, graphql],
    liveLink: "https://thegameawards.dreamwave.live/",
  },
  {
    heading: "ShedView Solution",
    img: "/shed.png",
    title: "ShedView Solution",
    description:
      "It is house design using configuration.",
    techStack: [amazon,threejs,node],
    liveLink: "https://shedview.shed-solutions.com/",
  },
  {
    heading: "Code-Ninja",
    img: "https://raw.githubusercontent.com/SumatM/Code-Ninja/43e9d8f70d5e16bede959a47347ffe46c7a0d263/frontend/src/assets/Screenshot%20(758).png",
    title: "Code Converter, Code Debugger",
    description:
      "Experience the future of coding with Code Ninja. Our advanced tool, powered by OpenAI API, offers code conversion, quality checks, and debugging. Elevate your coding skills, write error-free code, and boost productivity with Code Ninja.",
    techStack: [react, typescript, chakra, promptEngineering, node],
    liveLink: "https://code-converter-brown.vercel.app/",
  },
  {
    heading: "JOKE GENERATOR",
    img: "https://raw.githubusercontent.com/SumatM/joke_genrator/main/frontend/public/Screenshot%20(787).png",
    title: "Genrative AI Joke Generator App",
    description:
      "Created a fun Joke Generator app using OpenAI API, delivering a delightful experience with witty and entertaining jokes. Let the app bring laughter to your day with clever humor!",
    techStack: [react,typescript,node,promptEngineering,express],
    liveLink: "https://joke-indol.vercel.app/",
  },
  {
    heading: "Pew Builder",
    img: "/pew.png",
    title: "Pew Builder",
    description:
      "It is pew builder using configuration.",
    techStack: [angular,threejs, socket,jquery,firebase,node,bootstrap],
    liveLink: "https://pewbuilder.com/",
  },
  {
    heading: "3D character Control",
    img: "/3d-character.png",
    title: "3D character Control",
    description:
      "It is game using keyboard.",
    techStack: [react, threejs, tailwind],
    liveLink: "https://romario-carter-3d-character.netlify.app/",
  },
  {
    heading: "Mint | Skip",
    img: "/mintor.png",
    title: "Mint | Skip",
    description:
      "Find the next great NFT — early.",
    techStack: [react, nextjs, tailwind, node],
    liveLink: "https://www.mintorskip.com/",
  },
  {
    heading: "Venture Group",
    img: "/ventur.png",
    title: "Venture Group",
    description:
      "Venturous Group is a Citytech™ business builder and investor.",
    techStack: [gsap,threejs,react, nextjs, tailwind, node],
    liveLink: "https://www.venturousgroup.com/",
  },
  {
    heading: "Chavalit Portfolio",
    img: "/chavalit.png",
    title: "Chavalit Portfolio",
    description:
      "Chavalit Frederick Tsao is the fourth-generation family business steward of TPC (Tsao Pao Chee) formerly known as IMC Pan Asia Alliance, IMCPAA Group. Chavalit is dedicated to promoting business reform and co-creating the well-being and happiness market economy.",
    techStack: [react, nextjs, tailwind, node],
    liveLink: "https://chavalittsao.vercel.app/",
  },
  {
    heading: "Snax Corporation",
    img: "/snax.png",
    title: "Snax Corporation",
    description:
      "Welcome to the Snaxverse —our community of snack enthusiasts is helping build new worlds, creating a new common language between brands and consumers, and more equalizing structures.",
    techStack: [react, nextjs, tailwind, node],
    liveLink: "https://www.snaxverse.com/",
  },
  {
    heading: "Sunny Side Up",
    img: "/sunny.png",
    title: "Sunny Side Up",
    description:
      "We build brand worlds for web3 and direct-to-consumer brands.",
    techStack: [react, gsap, nextjs, threejs, node],
    liveLink: "https://sn-sun-vv2l.vercel.app/",
  },
  {
    heading: "DIAMONDLAND",
    img: "https://raw.githubusercontent.com/chaudhari014/legit-building-8885/main/banner/Screenshot%20(672).png",
    title: " CaratLane Clone",
    description:
      "Diamondland is an e-commerce website specializing in jewelry, offering customers a wide range of high-quality jewelry at affordable prices. They also provide personalized gift options for your loved ones.",
    techStack: [html, javascript, css],
    liveLink: "https://diamond-land.netlify.app/index.html",
  },
  {
    heading: "SPENDWISER",
    img: "https://user-images.githubusercontent.com/112808279/238118882-e4441c6a-8b1e-418d-b228-7132e40a40d4.png",
    title: "Money Manager App",
    description:
      " SpendWiser is an invaluable tool for anyone looking to manage their monthly budget and keep track of their spending. With its user-friendly interface and comprehensive features, SpendWiser makes it easy to stay on top of your finances and ensure that you are meeting your financial goals.",
    techStack: [react, chakra, redux, chartjs],
    liveLink: "https://hilarious-wood-568-fw21-0275-updated1.vercel.app/",
  },
];
